<template>
  <div>
    <Row style="margin-top: 10px;text-align: left">
       <i-col>
          <Card>
           <Form ref="searchForm" inline :model="searchForm">
            <FormItem label="项目名" prop="project" :label-width="58">
              <i-select v-model="searchForm.project" style="min-width: 218px" @on-change="handleProjectOnChange">
                <i-option v-for="(item, index) in projectOptions" :value="item.id" :key="index" :label="item.name"></i-option>
              </i-select>
            </FormItem>
           </Form>
           <Table :columns="columns" :data="tableData" height="300"/>
         </Card>
         <Card>
           <Form ref="searchFormUser" inline :model="searchFormUser">
            <FormItem label="用户名" prop="project" :label-width="58">
              <i-select v-model="searchFormUser.id" style="min-width: 218px" @on-change="handleUserOnChange">
                <i-option v-for="(item, index) in no_select_user" :value="item" :key="index" :label="item"></i-option>
              </i-select>
            </FormItem>
           </Form>
           <Table :columns="columnsProject" :data="tableDataProject" height="300"/>
        </Card>
      </i-col>
    </Row>
  </div>
</template>
<script>
import { getAllProjects as getAllProjectsGit, getAllUsers as getAllUsersGit, getProjectUsers as getProjectUsersGit } from '@/api/tools/gitlab'
import { getAllProjects as getAllProjectsSvn, getAllUsers as getAllUsersSvn, getProjectUsers as getProjectUsersSvn } from '@/api/tools/svn'

export default {
  name: 'ProjectDashboard',
  components: {
  },
  data () {
    return {
      roleListGit: [
        { id: 10, name: 'GUEST_ACCESS', dec: '访客' },
        { id: 20, name: 'REPORTER_ACCESS ', dec: '测试人员' },
        { id: 30, name: 'DEVELOPER_ACCESS ', dec: '开发人员' },
        { id: 40, name: 'MAINTAINER_ACCESS ', dec: '项目经理' },
        { id: 50, name: 'OWNER_ACCESS ', dec: '管理员' }
      ],
      roleListSvn: [
        { id: 0, name: 'No Access', dec: '无权限' },
        { id: 1, name: 'Read Only', dec: '只读' },
        { id: 2, name: 'Read Write', dec: '可读可写' }
      ],
      disabledSel: true,
      no_select_user: [],
      currentProject: '',
      detail: {},
      isAdmin: false,
      tableData: [],
      tableDataProject: [],
      columns: [],
      columnsAll: [
        { title: '用户名', key: 'name', align: 'center' },
        {
          title: 'Git角色',
          align: 'center',
          key: 'access_level',
          render: (h, params) => {
            return h('span', params.row.access_level ? this.roleListGit.filter(item => item.id === parseInt(params.row.access_level))[0].dec : '')
          }
        },
        {
          title: 'Svn权限',
          align: 'center',
          key: 'permission',
          render: (h, params) => {
            return h('span', params.row.permission ? this.roleListSvn.filter(item => item.id === parseInt(params.row.permission))[0].dec : '')
          }
        }
      ],
      columnsProject: [
        { title: '项目名', key: 'name', align: 'center', minWidth: 100 },
        { title: 'Git/Svn', key: 'type', align: 'center', minWidth: 100 }
      ],
      searchForm: {
        project: null
      },
      searchFormUser: {
        id: ''
      },
      projectOptions: []
    }
  },
  methods: {
    getNoSelectUser () {
      let that = this
      that.no_select_user = []
      getAllUsersGit().then(res => {
        if (res.status === 200) {
          let result = res.data
          for (let i in result) {
            if (result[i].username && that.no_select_user.indexOf(result[i].username) === -1) {
              that.no_select_user.push(result[i].username)
            }
          }
        }
      })
      getAllUsersSvn().then(res => {
        if (res.status === 200) {
          let result = res.data
          for (let i in result) {
            if (result[i] && that.no_select_user.indexOf(result[i]) === -1) {
              that.no_select_user.push(result[i])
            }
          }
        }
      })
    },
    searchReset () {
      this.searchForm = {
        project: null
      }
    },
    handleProjectOnChange (value) {
      console.log(value)
      this.currentProject = value
      let obj = this.projectOptions.filter(item => item.id === value)[0]
      this.getProjectMemberList(value, obj.type, obj.node)
      if (obj.type === 'git') {
        this.columns = this.columnsAll.filter(item => item.key !== 'permission')
      } else {
        this.columns = this.columnsAll.filter(item => item.key !== 'access_level')
      }
    },
    handleUserOnChange (value) {
      this.tableDataProject = []
      for (let i in this.projectOptions) {
        let params = {
          project_id: this.projectOptions[i].id,
          node: this.projectOptions[i].node,
          size: 9999,
          page: 1
        }
        if (this.projectOptions[i].type === 'git') {
          getProjectUsersGit(params).then(res => {
            let members = res.data.results
            if (members.filter(item => item.name === value).length > 0 && this.tableDataProject.filter(m => m.id === this.projectOptions[i].id).length === 0) {
              this.tableDataProject.push({
                id: this.projectOptions[i].id,
                name: this.projectOptions[i].name,
                type: this.projectOptions[i].type
              })
            }
          }).catch(res => {
            console.log(res.response)
          })
        } else {
          getProjectUsersSvn(params).then(res => {
            let members = res.data.results
            if (members.filter(item => item.name === value).length > 0 && this.tableDataProject.filter(m => m.id === this.projectOptions[i].id).length === 0) {
              this.tableDataProject.push({
                id: this.projectOptions[i].id,
                name: this.projectOptions[i].name,
                type: this.projectOptions[i].type
              })
            }
          }).catch(res => {
            console.log(res.response)
          })
        }
      }
    },
    // 获取项目用户列表
    getProjectMemberList (projectId, type, node) {
      console.log(node)
      this.tableLoading = true
      let params = {
        project_id: projectId,
        node: node,
        size: 9999,
        page: 1
      }
      if (type === 'git') {
        getProjectUsersGit(params).then(res => {
          this.tableData = res.data.results
          this.tableLoading = false
        }).catch(res => {
          console.log(res.response)
          this.tableLoading = false
        })
      } else {
        getProjectUsersSvn(params).then(res => {
          this.tableData = res.data.results
          this.tableLoading = false
        }).catch(res => {
          console.log(res.response)
          this.tableLoading = false
        })
      }
    },
    getProjectOptions () {
      let that = this
      that.projectOptions = []
      getAllProjectsGit().then(res => {
        if (res.status === 200) {
          let result = res.data
          for (let i in result) {
            if (result[i].name) {
              that.projectOptions.push({
                id: result[i].id,
                name: result[i].name,
                type: result[i].type,
                node: result[i].node
              })
            }
          }
        }
      })
      getAllProjectsSvn().then(res => {
        if (res.status === 200) {
          let result = res.data
          for (let i in result) {
            if (result[i].name) {
              that.projectOptions.push({
                id: result[i].id,
                name: result[i].name,
                type: result[i].type,
                node: result[i].node
              })
            }
          }
        }
      })
    },
    initData () {
      if (this.$store.state.user.superuser) {
        this.isAdmin = true
      } else {
        this.isAdmin = false
      }
    }
  },
  mounted () {
    this.getProjectOptions()
    this.getNoSelectUser()
    this.initData()
  }
}
</script>

<style lang="less" scoped>
.count-style{
  font-size: 50px;
}
@baseColor: ~"#dc9387";
.countto-page-row{
  height: 200px;
}
.count-to-con{
  display: block;
  width: 100%;
  text-align: center;
}
.count-text{
  font-size: 50px;
  color: @baseColor;
}
.slot-text{
  font-size: 22px;
}
.unit-class{
  font-size: 30px;
  color: @baseColor;
}
</style>
